import React from "react";
import { Link } from "react-router-dom";
import { club } from "../mock/mock";

function Legal({ title, subtitle, children }) {
  return (
    <div>
      <section className="bg-primary text-primary-foreground pt-32 pb-14">
        <div className="max-w-3xl mx-auto px-5 lg:px-8">
          <span className="inline-block text-accent text-sm font-600 uppercase tracking-[0.25em] mb-3">
            Rechtliches
          </span>
          <h1 className="font-serif text-4xl md:text-5xl font-600">{title}</h1>
          {subtitle && (
            <p className="mt-3 text-primary-foreground/80 text-lg font-300">{subtitle}</p>
          )}
        </div>
      </section>
      <section className="py-16 bg-background">
        <div className="max-w-3xl mx-auto px-5 lg:px-8">{children}</div>
      </section>
    </div>
  );
}

function H2({ children }) {
  return (
    <h2 className="font-serif text-2xl font-600 text-foreground mt-10 mb-3 first:mt-0">
      {children}
    </h2>
  );
}

function P({ children }) {
  return <p className="text-muted-foreground leading-relaxed mb-3">{children}</p>;
}

function List({ items }) {
  return (
    <ul className="list-disc pl-5 space-y-1.5 text-muted-foreground mb-3">
      {items.map((it, i) => (
        <li key={i} className="leading-relaxed">{it}</li>
      ))}
    </ul>
  );
}

export default function Datenschutz() {
  return (
    <Legal
      title="Datenschutzerklärung"
      subtitle="Informationen zur Verarbeitung personenbezogener Daten gemäß Art. 13 DSGVO."
    >
      <H2>1. Verantwortlicher</H2>
      <P>
        Verantwortlich für die Datenverarbeitung auf dieser Website ist der
        Vorstand des {club.name}:
      </P>
      <P>
        {club.name}
        <br />
        {club.address.heim}, {club.address.city}
        <br />
        E-Mail:{" "}
        <a
          href={`mailto:${club.emails.vorstand}`}
          className="text-primary font-500 underline underline-offset-2 break-all"
        >
          {club.emails.vorstand}
        </a>
      </P>

      <H2>2. Grundsätzliches & Cookies</H2>
      <P>
        Der Schutz deiner personenbezogenen Daten ist uns wichtig. Diese
        Website ist bewusst datensparsam gestaltet: Sie verwendet{" "}
        <strong className="text-foreground">keine Cookies</strong>, kein
        Tracking, keine Analyse- oder Statistik-Tools (z. B. kein Google
        Analytics) und keine Werbe-Netzwerke. Es werden keine Profile über dein
        Nutzungsverhalten erstellt. Auch Schriftarten und Bilder werden direkt
        von unserem Server ausgeliefert (kein Google Fonts, keine externen
        Bild-CDNs). Eine Übertragung an Dritte findet dabei nicht statt. Einzige
        Ausnahme ist die interaktive Gewässerkarte, die erst nach deinem
        aktiven Klick geladen wird (siehe Punkt 6 „Kartendienst").
      </P>

      <H2>3. Zugriffsdaten / Server-Logfiles (Hosting)</H2>
      <P>
        Beim Aufruf der Website werden durch den Hosting-Anbieter automatisch
        Informationen erfasst, die dein Browser übermittelt (sog.
        Server-Logfiles). Dies sind in der Regel:
      </P>
      <List
        items={[
          "aufgerufene Seite / Datei",
          "Datum und Uhrzeit des Zugriffs",
          "übertragene Datenmenge",
          "Browsertyp und -version, verwendetes Betriebssystem",
          "Referrer-URL (die zuvor besuchte Seite)",
          "gekürzte bzw. verarbeitete IP-Adresse",
        ]}
      />
      <P>
        Diese Daten dienen ausschließlich dem technisch fehlerfreien Betrieb und
        der Sicherheit der Website. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f
        DSGVO (berechtigtes Interesse). Eine Zusammenführung dieser Daten mit
        anderen Datenquellen findet nicht statt.
      </P>

      <H2>4. Kontaktaufnahme per E-Mail</H2>
      <P>
        Auf der Website findest du E-Mail-Adressen sowie Formulare, die beim
        Absenden dein eigenes E-Mail-Programm öffnen (z. B. für allgemeine
        Fragen oder eine Anfrage zur Warteliste einer Mitgliedschaft). Es werden
        dabei <strong className="text-foreground">keine Daten auf dieser
        Website gespeichert</strong> oder an uns über die Website übertragen. Die
        E-Mail sendest du selbst über dein Postfach an uns. Die von dir
        mitgeteilten Daten (z. B. Name und E-Mail-Adresse) verarbeiten wir
        ausschließlich zur Bearbeitung deiner Anfrage (Art. 6 Abs. 1 lit. b
        bzw. f DSGVO) und bewahren sie nur so lange auf, wie es dafür
        erforderlich ist.
      </P>

      <H2>5. Externe Links</H2>
      <P>
        Diese Website verlinkt auf externe Angebote (u. a. Online-Angelkarten
        über „hejfish", die App „Angelflix" sowie die Fischerprüfung). Beim
        Anklicken verlässt du unsere Website; für die Datenverarbeitung auf den
        Zielseiten sind ausschließlich deren Betreiber verantwortlich. Bitte
        beachte dort die jeweiligen Datenschutzhinweise.
      </P>

      <H2>6. Kartendienst (OpenStreetMap)</H2>
      <P>
        Auf der Seite „Gewässer" bieten wir eine interaktive Karte an. Diese
        wird aus Datenschutzgründen <strong className="text-foreground">nicht
        automatisch</strong> geladen: Erst wenn du aktiv auf „Karte laden"
        klickst, werden Kartenkacheln von den Servern der OpenStreetMap
        Foundation (St John's Innovation Centre, Cowley Road, Cambridge, CB4
        0WS, Vereinigtes Königreich) abgerufen. Dabei wird deine IP-Adresse an
        OpenStreetMap übertragen. Rechtsgrundlage ist deine Einwilligung durch
        den Klick (Art. 6 Abs. 1 lit. a DSGVO). Ohne Klick findet keine
        Übertragung statt. Weitere Infos:{" "}
        <a
          href="https://wiki.osmfoundation.org/wiki/Privacy_Policy"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary font-500 underline underline-offset-2 break-all"
        >
          OpenStreetMap Datenschutzerklärung
        </a>
        .
      </P>

      <H2>7. SSL-/TLS-Verschlüsselung</H2>
      <P>
        Diese Seite nutzt aus Sicherheitsgründen eine SSL-/TLS-Verschlüsselung.
        Eine verschlüsselte Verbindung erkennst du an „https://" in der
        Adresszeile deines Browsers.
      </P>

      <H2>8. Deine Rechte</H2>
      <P>Dir stehen als betroffene Person folgende Rechte zu:</P>
      <List
        items={[
          "Auskunft über die zu deiner Person gespeicherten Daten (Art. 15 DSGVO)",
          "Berichtigung unrichtiger Daten (Art. 16 DSGVO)",
          "Löschung deiner Daten (Art. 17 DSGVO)",
          "Einschränkung der Verarbeitung (Art. 18 DSGVO)",
          "Datenübertragbarkeit (Art. 20 DSGVO)",
          "Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)",
        ]}
      />
      <P>
        Zur Ausübung deiner Rechte genügt eine formlose E-Mail an{" "}
        <a
          href={`mailto:${club.emails.vorstand}`}
          className="text-primary font-500 underline underline-offset-2 break-all"
        >
          {club.emails.vorstand}
        </a>
        .
      </P>

      <H2>9. Beschwerderecht bei der Aufsichtsbehörde</H2>
      <P>
        Dir steht ein Beschwerderecht bei einer Datenschutz-Aufsichtsbehörde zu.
        Zuständig ist das Bayerische Landesamt für Datenschutzaufsicht (BayLDA),
        Promenade 18, 91522 Ansbach.
      </P>

      <H2>10. Aktualität & Änderungen</H2>
      <P>
        Diese Datenschutzerklärung gibt den aktuellen Stand wieder. Bei
        Weiterentwicklung der Website können Anpassungen erforderlich werden;
        die jeweils aktuelle Fassung ist auf dieser Seite abrufbar.
      </P>

      <div className="mt-8">
        <Link to="/impressum" className="text-primary font-500 underline underline-offset-2">
          Zum Impressum
        </Link>
      </div>
    </Legal>
  );
}
